import { useEffect, useState } from 'react'
import { lumi } from '../lib/lumi'
import EditableText from './EditableText'

interface BannerContent {
  _id: string
  content?: {
    line1?: string
    line2?: string
  }
}

const DEFAULTS = {
  line1: 'Worldwide shipping',
  line2: 'Free delivery within Europe',
}

const TopBanner = () => {
  const [doc, setDoc] = useState<BannerContent | null>(null)

  useEffect(() => {
    let mounted = true
    const load = async () => {
      try {
        const res = await lumi.entities.site_content.list({
          filter: { page: 'global', section: 'topBanner' },
          limit: 1,
        })
        const existing = res?.list?.[0]
        if (existing) {
          if (mounted) setDoc(existing)
          return
        }
        // Create the document with defaults so admins can edit it inline
        const created = await lumi.entities.site_content.create({
          page: 'global',
          section: 'topBanner',
          content: { line1: DEFAULTS.line1, line2: DEFAULTS.line2 },
          creator: 'system',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        })
        if (mounted) setDoc(created)
      } catch (err) {
        console.error('[TopBanner] Failed to load banner content:', err)
      }
    }
    load()
    return () => {
      mounted = false
    }
  }, [])

  const line1 = doc?.content?.line1 ?? DEFAULTS.line1
  const line2 = doc?.content?.line2 ?? DEFAULTS.line2

  return (
    <div
      className="sticky top-0 left-0 right-0 z-[60] text-white text-center px-4 py-2 text-xs sm:text-sm tracking-wide"
      style={{ backgroundColor: '#722F37' }}
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-x-3 gap-y-0.5">
        {doc?._id ? (
          <EditableText
            collection="site_content"
            documentId={doc._id}
            field="content.line1"
            value={line1}
            type="text"
            as="span"
            className="font-medium"
            onSave={(newValue) =>
              setDoc((prev) =>
                prev
                  ? { ...prev, content: { ...prev.content, line1: newValue } }
                  : prev
              )
            }
          >
            {line1}
          </EditableText>
        ) : (
          <span className="font-medium">{line1}</span>
        )}
        <span className="hidden sm:inline opacity-60">•</span>
        {doc?._id ? (
          <EditableText
            collection="site_content"
            documentId={doc._id}
            field="content.line2"
            value={line2}
            type="text"
            as="span"
            className="opacity-90"
            onSave={(newValue) =>
              setDoc((prev) =>
                prev
                  ? { ...prev, content: { ...prev.content, line2: newValue } }
                  : prev
              )
            }
          >
            {line2}
          </EditableText>
        ) : (
          <span className="opacity-90">{line2}</span>
        )}
      </div>
    </div>
  )
}

export default TopBanner
